import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { DashboardLayout } from "component/layout/dashboard";
import { OneCrmIframe } from "component/shared/iframe/onecrm";
import { FeatherIcon } from "component/shared/feather-icon";

interface Props {

}

class Component extends React.Component<Props> {

	public render() {
		const title = "Reports";
		return (
			<DashboardLayout
				title={title}
				header={
					<Mui.Typography variant="h1">
						<FeatherIcon>
							<Icons.User />
						</FeatherIcon>
						{title}
					</Mui.Typography>
				}
				iframe={<OneCrmIframe url="/admin/reports/Reports.aspx" />}
			/>
		);
	}

}

export const OneReportsPage = Component;